import { Col, Container, Row, Accordion } from 'react-bootstrap';
import { motion } from 'framer-motion';
import brandData from '../../data/brandData.json';

const FAQ = () => {
  const accordionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: index * 0.1 }
    })
  }

  return (
    <section id='brand-faq' className='section-lg bg-light overflow-hidden'>
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 className="underline-after position-relative text-center z-0"
              initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              <span className="position-relative z-1 bg-white text-primary px-3">FAQ</span>
            </motion.h6>
            <motion.h1 className="d-block text-gradiant text-center fw-semibold"
              initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }}
            >
              Common questions
            </motion.h1>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Accordion flush>
              {brandData.faqs.map((faq, index) => (
                <motion.div className={index !== brandData.faqs.length - 1 ? 'mb-3' : ''}
                  key={faq.id} variants={accordionVariants} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={index}
                >
                  <Accordion.Item eventKey={index.toString()} className="rounded-4 overflow-hidden border shadow-sm">
                    <Accordion.Header>
                      {faq.question}
                    </Accordion.Header>
                    <Accordion.Body className="pt-0 pb-3 text-secondary">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                </motion.div>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default FAQ;
